import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { getFaqFrontEnd } from "../../reducers/frontEndReducer";

const FaqSection = () => {
  const dispatch = useDispatch();
  const [openIndex, setOpenIndex] = useState(null); 

  useEffect(() => {    
    dispatch(getFaqFrontEnd());
  }, [dispatch]);
   
  const { getFaqFrontEndData } = useSelector((state) => state.frontEndReducer);
  
const toggleFAQ = (index) => {
    setOpenIndex(prevIndex => (prevIndex === index ? null : index));
  };

  return (
    <div className="py-5">
      <h2 className="text-center mb-5 faq-title">Frequently asked questions (FAQs)</h2>
      <div className="faq-wrapper">
        {getFaqFrontEndData.faq?.map((item, index) => (
          <div
            key={item.id}
            className="faq-item"
            onClick={() => toggleFAQ(index)}
          >
            <div className="faq-question d-flex justify-content-between align-items-center">
              <h5>{item.question}</h5>
              <span className="faq-icon">{openIndex === index ? '−' : '+'}</span>
            </div>
            {openIndex === index && (
              <div className="faq-answer mt-2">
                <p>{item.answer}</p>
              </div>
            )}
          </div>
        ))}

      </div>
    </div>
  );
};

export default FaqSection;

